<template>
  <div id="aiInput" class="aiTranslateInput" :class="{ 'enterprise-text-input': enterpriseMode }">
    <div class="chat-bottom">
      <div class="bottom-box">
        <div class="input-box" @click="onTextareaFocus">
          <div class="input-textarea">
            <textarea id="chat-input" maxlength="5000" ref="textareaRef" @keydown.enter="handleEnter"
              v-model="inputMessage" class="textareaInput textarea-attach" :placeholder="$t('translate_ai_placeholder')"
              rows="3" @input="adjustHeight" />
            <div class="textarea-attach auto-text">{{ inputMessage }}</div>
          </div>
        </div>
        <div class="input-send">
          <div class="option-right">
            <!-- 这里显示游客免费使用次数 -->
            <span class="char-title" v-if="!token">{{ onBottomVisitorRemainNum() }}</span>
            <span class="char-title" v-if="token">
              {{ enterpriseMode ? `可用字符数：${charNum.toLocaleString()}` : onBottomRemainNum() }}
            </span>
            <el-popover ref="popoverRef" width="200" trigger="hover" popper-class="engine-popover" placement="top">
              <template #reference>
                <WorkbenchIcon v-if="token && enterpriseMode" name="info" :size="13" class="enterprise-quota-info" />
                <i class="iconfont icon-icon_question" v-else-if="token"
                  style="font-size: 14px; line-height: 12px; color: #8C8C8C; margin-left: 4px;cursor: pointer" />
              </template>
              <div class="popoverDiv">
                <div class="title">{{$t("translate_ai_char_num_tip")}}</div>
              </div>
            </el-popover>
          </div>
          <div class="send-box">
            <div class="textarea-length-text">{{ inputMessage.length }} / 5000</div>
            <div :class="`${ inputMessage.length > 0 && !inputDisable ? 'send' : 'unsend'}`" @click="((event)=>{ onSend() })">{{ $t('dcolingo_translate') }}</div>
            <!-- <i class="iconfont icon-icon_send1"
            :class="`${ inputMessage.length > 0 && !inputDisable ? 'send' : 'unsend'}`"
            @click="((event)=>{ onSend() })" /> -->
          </div>
         
        </div>
        <!-- <div class="input-option" @click.stop>
          <div class="option-left">
          </div>
          <div class="option-right">
            <span class="char-title" >{{ onBottomRemainNum() }}</span>
            <el-popover
                ref="popoverRef"
                width="auto"
                trigger="hover"
                popper-class="custom-popover"
                placement="top"
            >
              <template #reference >
                <i class="iconfont icon-icon_question" style="font-size: 14px; line-height: 12px; color: #8C8C8C; margin-left: 4px;cursor: pointer" />
              </template>
              <div class="popoverDiv" style="width: 200px" v-if="onCheckBottomRemainNum()">
                <div class="title" >{{$t("chat_input_question_tip0").replace("*", charAllNum || 0)}}</div>
                <div class="title" style="margin-top: 10px;">{{$t("chat_input_question_tip1").replace("*", config.aiChatTrialNumPerMon || 0)}}</div>
                <div class="title" >{{$t("chat_input_question_tip2").replace("*", config.aiChatTrialNumPerDay || 0)}}</div>
                <div class="title" >{{$t("chat_input_question_tip3")}}</div>
              </div>
              <div class="popoverDiv" style="min-width: 100px" v-if="!onCheckBottomRemainNum()">
                <div class="title" >{{$t("chat_input_question_tip0").replace("*", charAllNum || 0)}}</div>
              </div>
            </el-popover>
          </div>
        </div> -->
        <!-- <div class="gradient-button-flow"></div> -->
      </div>
      <!-- <div class="chat-bottom-blank" :style="`height: ${ type != 1 ? '61px' : '20px'}`"></div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
import eventBus from 'vue3-eventbus'
const { t } = useI18n()
import useUserStore from "@/store/modules/user";
import useBasicStore from "@/store/modules/basic";
import {storeToRefs} from "pinia";
import { Loading } from '@element-plus/icons-vue';
import type { MessageEngine } from '@/data/chat/Message';
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
// import { getRequestConfig } from "@/net/upload";
const userStore = useUserStore();
const basicStore = useBasicStore();
let call = defineEmits(["sendMessage", "deleteMessage", "engineUpdata", "downloadAiChat", "onSelectChange", "onDownloadAiChat", "onDeleteMessage", "openLogin", "onProBuy"])
let inputMessage = ref("")
let inputHeight = ref()
let charNum = ref(0)
let trialNum = ref(0)
let charAllNum = ref(0)
let currentModeInfo = ref()
let currentMode = ref()
let mode = ref([])
let seniorMode = ref([])
let reasoningMode = ref([])

let showRotateAnimation  = ref(false)

const textareaRef = ref(null);
const inputDisable = ref(false)
const { token, userInfo, bizTeamInfo } = storeToRefs(userStore);

interface LoginDialog {
  loginOpenDialog: () => void;
  loginCloseDialog: () => void;
}

const { $loginCom } = useNuxtApp();
const showLogin = () => {
	$loginCom.open();
};

defineExpose({ setDisable, onUpdataRemainCharsNum, getDisable, updataRemainFreeNum, onShowRotateAnimation, clearInputText, updataEngine, getTrialNum})

watch(
    () => inputMessage.value,
    () => {
      adjustHeight() 
    }
)

watch(
  () => userInfo.value,
  () => {
    updataBusinessCharNum()
  }
)

watch(
  () => charNum.value,
  () => {
    console.log("charNum.value====", charNum.value)
  }
)

function getTrialNum() {
  return trialNum.value ?? 0
}

const props = withDefaults(defineProps<{
  enterpriseMode?: boolean
}>(), {
  enterpriseMode: false,
})
const enterpriseMode = computed(() => props.enterpriseMode)

const timerIds = ref<number[]>([]);

function onSend(drakParams?: any) {
  if (inputDisable.value || inputMessage.value.length == 0){
    return
  }
  // if (currentModeInfo.value && currentModeInfo.value.tokenCostRatio != '0') {
  //   call('onProBuy')
  //   return
  // }
  if (!token.value) {
    showLogin()
    return
  }

  const timerId = setTimeout(() => {
    textareaRef.value?.blur();
  }, 0);
  timerIds.value.push(timerId);
  console.log('inputMessage.value==', inputMessage.value)
  call("sendMessage", inputMessage.value, false, drakParams)
}

function clearInputText () {
  inputMessage.value = ""
}

function adjustHeight() {
    const textarea = textareaRef.value;
    if (textarea) {
      textarea.style.height = 'auto'; // 重置高度
      textarea.style.height = textarea.scrollHeight + 'px'; // 根据内容设置高度
    }
}

function handleEnter(event) {
  event.preventDefault();
  if (inputDisable.value || inputMessage.value.length == 0){
    return
  }
  const timerId1 = setTimeout(() => {
    textareaRef.value?.blur();
  }, 0);
  timerIds.value.push(timerId1);
  call("sendMessage", inputMessage.value)
}

function setDisable(isDisable) {
  console.log('setDisable==', isDisable)
  inputDisable.value = isDisable 
}

function getDisable() {
  return inputDisable.value
}

onUnmounted(()=>{
  timerIds.value.forEach(id => clearTimeout(id));
  timerIds.value = [];
})

function updataRemainFreeNum(engineInfo: MessageEngine, allEngineMap: object) {
  currentModeInfo.value = engineInfo 
  console.log("allEngineMap", allEngineMap)
  let ordinary = []
  let senior = []
  let reasoning = []
  Object.keys(allEngineMap).forEach(key => {
    let engine = allEngineMap[key]
    engine.describe = t(`${key}_describe`)

    if (engine.highLevelFlag == 0 && engine.showFlag == 1) {
      ordinary.push(engine)
    }else if (engine.highLevelFlag == 1 && engine.showFlag == 1) {
      senior.push(engine)
    }else if(engine.highLevelFlag == 2 && engine.showFlag == 1){
      reasoning.push(engine)
    }
  });
  ordinary = ordinary.sort((a, b) => {
    return a.sort - b.sort
  })
  senior = senior.sort((a, b) => {
    return a.sort - b.sort
  })
  reasoning = reasoning.sort((a, b) => {
    return a.sort - b.sort
  })
  mode.value = ordinary
  seniorMode.value = senior
  reasoningMode.value = reasoning
  console.log('reasoningMode.value==',reasoningMode.value)
  call("engineUpdata", engineInfo)
}

function onUpdataRemainCharsNum(remainInfo) {
  console.log(remainInfo,'===remainInfo')
  charNum.value = remainInfo.remainCharsNum
  trialNum.value = remainInfo.remainTrialNum
  charAllNum.value = remainInfo.remainCharsAll
}

function onBottomRemainNum() {
  // todo 临时处理
  if (currentModeInfo.value && currentModeInfo.value.engineName == 'glm-4.5-flash') {
    return t('pro_subscribe_free')
  }
  return t('chat_have_all_char').replace("*", charNum.value.toLocaleString())
}

// 游客
function onBottomVisitorRemainNum() {
  console.log("config.value.aiChatTrialNumPerDay", currentModeInfo.value)
  // if (currentModeInfo.value && currentModeInfo.value.engineName == 'gpt-4o-mini') {
  //   return t('visitor_text_translate_num').replace("*", `${getTrialNum()}`)
  // }
  return ''
}

function updataEngine(engineInfo: MessageEngine) {
  currentModeInfo.value = engineInfo 
  if (engineInfo) {
    // let charNewNum = userStore.getRoleAITextTranlsateCharacterByNum(currentModeInfo.value)
    // console.log("charNum====", typeof charNewNum)
    // charNum.value = charNewNum
  }
  // trialNum.value = userInfo.value.aiTransCouldTrialNum
}

function onShowRotateAnimation () {
  showRotateAnimation.value = false
}

function onTextareaFocus() {
  textareaRef.value && textareaRef.value.focus()
}

function getHomePageConfig() {
  // getRequestConfig().then((data)=>{
  //   if (data.code == "1") {
  //     userStore.setConfig(data.data)
  //     trialNum.value = config.value.visitorRemainAiTransCount
  //   }
  // })
  basicStore.getHomePageConfig()
  updataBusinessCharNum()
}

function updataBusinessCharNum() {
  let charBusinessNum = bizTeamInfo.value?.remainServiceWords || 0
  if (bizTeamInfo.value?.remainPackageWords) {
    charBusinessNum = charBusinessNum + bizTeamInfo.value?.remainPackageWords
  }
  charNum.value = charBusinessNum
}

onMounted(()=>{
  getHomePageConfig()
})

</script>

<style lang="less">
.aiTranslateInput {
  z-index: 1;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  display: flex;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 100%;
  .chat-bottom {
    flex-grow: 1;
    width: 100%;
    position: relative;
    .bottom-box {
      --padding: 14px;
      cursor: text;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      font-size: 16px;
      line-height: 28px;
      box-shadow: none;
      background-color: white;
      // background-color: transparent;
      // background-color: #F2F2F2;
      border-radius: 10px;
      flex-direction: column;
      display: flex;
      position: relative;
      justify-content: space-between;
      // border: #03DAFE 1px solid;
      .files-box {
        display: flex;
        flex-direction: row;
        padding: 20px;
      }
      .char-line {
        margin: 0 20px;
        background-color: #F5F5F5;
        height: 1px;
      }
      .input-box {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 16px 19px 16px 19px;
        display: flex;
        overflow: hidden;
        .input-textarea {
          width: 100%;
          min-height: 28px;
          max-height: 200px;
          position: relative;
          .textareaInput {
            resize: none;
            color: var(--text-color);
            caret-color: var(--text-color);
            background-color: transparent;
            position: absolute;
            max-height: 200px;
          }
          .textarea-attach {
            font-size: inherit;
            line-height: inherit;
            word-break: break-word;
            white-space: pre-wrap;
            border: none;
            width: 100%;
            margin: 0;
            padding: 0;
            font-family: inherit;
            display: block;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            overflow: auto;
          }
          .auto-text {
            visibility: hidden;
            pointer-events: none;
          }
          .textareaInput:focus {
            outline: none;
            border-color: transparent; /* 聚焦时的边框颜色 */
          }
        }
      }
      .input-send {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px 10px 20px;
        .option-right {
          display: flex;
          align-items: center;
          .char-title {
            font-size: 14px;
            color: #595959;
          }
          .icon-icon_download1 {
            font-size: 16px;
            color: #2590E1;
            cursor: pointer;
          }
        }
        .line {
          width: 1px;
          height: 16px;
          background-color: #BFBFBF;
          margin: 0 8px;
        }
        .icon-icon_send1 {
          font-size: 20px;
          margin-left: 10px;
        }
        .unsend {
          background-color: #BFBFBF;
          padding: 0px 10px;
          border-radius: 5px;
          min-width: 46px;
          font-size: 14px;
          font-weight: bold;
          line-height: 40px;
          text-align: center;
          color: white;
          margin-left: 10px;
        }
        .send {
          background-color: #2590E1;
          color: white;
          cursor: pointer;
          padding: 0px 10px;
          border-radius: 5px;
          min-width: 46px;
          font-size: 14px;
          font-weight: bold;
          line-height: 40px;
          margin-left: 10px;
          text-align: center;
        }
        .icon-icon_upload_11 {
            font-size: 16px;
            color: #595959;
            cursor: pointer;
            &:hover{
              color: #2590E1;
            }
        }
      }
      .input-option {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background-color:#F5F5F5;
        border-radius: 0 0 10px 10px;
        .option-left {
          display: flex;
          align-items: center;
          
        }
        .option-right {
          display: flex;
          align-items: center;
          .char-title {
            font-size: 14px;
            color: #595959;
          }
          .icon-icon_download1 {
            font-size: 16px;
            color: #2590E1;
            cursor: pointer;
          }
        }
      }
      .send-box {
        display: flex;
        flex-direction: row;
        .textarea-length-text {
          color: var(--text-color1);
          font-size: 16px;
          line-height: 40px;
          text-align: center;
        }
      }
    }
    .chat-bottom-blank {
      height: 61px;
      width: 100%;
      background-color: white;
    }
  }
  ::v-deep .custom-chat {
    padding:50px !important;  
  }

}
.mode-top {
  display: flex;
  flex-direction: row;
  padding: 8px 15px 0px 15px;
  align-items: center;
  .mode-title {
    font-size: 12px;
    color: #262626;
    font-weight: bold;
  }
  .lock {
    margin-left: 10px;
    background: linear-gradient( 90deg, #FEECDE 0%, #FECD9C 100%);
    border-radius: 2px 2px 2px 2px;
    padding: 0 5px;
    .lock-title {
      color: #894825;
      font-size: 12px;
    }
  }
}
.mode-engine-dev {
  display: flex;
  flex-direction: column;
  .mode-subTitle {
    margin-left: 6px;
    color: #8C8C8C;
    font-size: 14px;
    white-space: normal;
  }
  .mode-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    .iconBg {
      width: 20px;
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
    .mode-engine-title {
      margin-left: 6px;
      color: #595959;
      font-size: 14px;
    }
    .mode-sub-title {
      color: #8C8C8C;
      font-size: 12px;
      margin-left: 10px;
    }
    .lock {
      margin-left: 10px;
      background: linear-gradient( 90deg, #FEECDE 0%, #FECD9C 100%);
      border-radius: 2px 2px 2px 2px;
      padding: 2px 5px;
      .lock-title {
        color: #894825;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}

.engine-popover.el-popover{
  background-color: #303133 !important;
  border-color: transparent !important;
  max-height: 300px;
  .el-popper__arrow::before {
    background: #303133 !important;
    border-color: transparent !important;
  }
}

.mode-tips-title {
  color: #FFFFFF;
  font-size: 12px;
  white-space: normal;
  font-weight: bold;
}

.el-dropdown-mode {
  z-index: 2000 !important;
}

.spinner {
  animation: spin 1s linear infinite; /* 旋转动画 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* 起始角度 */
  }
  100% {
    transform: rotate(360deg); /* 结束角度 */
  }
}
</style>

<style scoped lang="scss">
.enterprise-text-input {
  --enterprise-primary: #2b7de9;
  --enterprise-ink: #1f2329;
  --enterprise-sub: #51565d;
  --enterprise-muted: #98a2b3;

  .chat-bottom {
    .bottom-box {
      border-radius: 0;

      .input-box {
        min-height: 172px;
        padding: 22px 18px;

        .input-textarea {
          max-height: 160px;

          .textareaInput,
          .textarea-attach {
            max-height: 160px;
            color: var(--enterprise-ink);
            font-size: 14px;
            line-height: 22px;
          }

          .textareaInput::placeholder {
            color: var(--enterprise-muted);
          }
        }
      }

      .input-send {
        box-sizing: border-box;
        min-height: 58px;
        padding: 10px 18px;
        background: #f7f9fc;
        border-top: 1px solid #eef1f5;

        .option-right {
          gap: 6px;

          .char-title {
            color: var(--enterprise-sub);
            font-size: 12.5px;
            font-weight: 600;
          }
        }

        .enterprise-quota-info {
          color: var(--enterprise-muted);
          cursor: help;
        }

        .send-box {
          align-items: center;
          gap: 12px;

          .textarea-length-text {
            color: var(--enterprise-muted);
            font-size: 12.5px;
            line-height: 38px;
          }

          .send,
          .unsend {
            box-sizing: border-box;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 98px;
            height: 38px;
            margin-left: 0;
            padding: 0 22px;
            color: #fff;
            font-size: 13.5px;
            font-weight: 700;
            line-height: 38px;
            border-radius: 8px;
          }

          .send {
            background: var(--enterprise-primary);
          }

          .unsend {
            background: #c3c9d1;
          }
        }
      }
    }
  }
}
</style>

<style>

@keyframes flow {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>

<style scoped>
/* 去掉 iconfont 的边框 */
.iconfont {
  border: none !important;
}

/* 去掉 el-icon 的边框 */
.el-icon {
  border: none !important;
}

/* 去掉焦点和悬停时的边框 */
.iconfont:focus, .iconfont:hover,
.el-icon:focus, .el-icon:hover {
  border: none !important;
  outline: none !important;
}

</style>
